"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleIndexOf = exports.indexOf2dArray = void 0;
var flatten_1 = __importDefault(require("lodash/flatten"));
/**
 * Finds the position in a 2D array of a specific value.
 * Returns the result as an array in the form [x, y] where the item is located, or false if the item could not be found.
 * @param {array} array2d
 * @param {any} value
 */
var indexOf2dArray = function (array2d, value, options) {
    if (options === void 0) { options = { stopBeforeRowIndex: Infinity }; }
    var index = flatten_1.default(array2d).indexOf(value);
    if (index === -1) {
        return false;
    }
    var numColumns = array2d[0].length;
    var row = Math.floor(index / numColumns);
    var col = index % numColumns;
    if (row < options.stopBeforeRowIndex) {
        return [row, col];
    }
    return false;
};
exports.indexOf2dArray = indexOf2dArray;
/**
 * Searches an array for all items that match a given value. Returns the result as a new array containing each index.
 * @param {array} values
 * @param {any} targetValue
 */
var multipleIndexOf = function (values, targetValue) {
    return values
        .map(function (value) { return value === targetValue; })
        .map(function (isMatch, index) { return (isMatch ? index : -1); })
        .filter(function (index) { return index >= 0; });
};
exports.multipleIndexOf = multipleIndexOf;
